import { z } from 'zod';
import { SettingsSchema } from '../../entities/organization/organization.schema';
import { LogoDataSchema } from '../../shared/logo.schema';
export const ShowOrgSettingsResponseSchema = z.object({
    data: SettingsSchema.extend({
        name: z.string(),
        logo: LogoDataSchema.optional()
    })
});

//# sourceMappingURL=show-org-settings.schema.js.map